module.exports = __webpack_public_path__ + "6ad396399f4022ccd1616cf11d0985be.woff";


//////////////////
// WEBPACK FOOTER
// ./~/clarity-ui/dist/fonts/open-sans-extrabold.woff
// module id = 1533
// module chunks = 0